// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/slick-theme.css
// module id = 1295
// module chunks = 10